<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/chevron.svg?raw'
export default {
  name: 'IconChevron',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
